import { useLemonadeContext, roundNumber } from "@/LemonadeProvider";

export function SaleHistory() {
    const { sales } = useLemonadeContext();

    const sorted = [...sales].sort((a, b) => b.date.getTime() - a.date.getTime());

    return (
        <section className="history-section sale-history">
            <h2 className="main-title">Eladások</h2>
            <ul>
                {sorted.length === 0 && <li>Nincs eladás.</li>}
                {sorted.map((sale) => (
                    <li key={sale.date.getTime()}>
                        <b>{sale.lemonade.name}</b> – {sale.amount} dl – {roundNumber(sale.price, 0)} Ft
                        <br />
                        <span style={{ color: "#bbb" }}>{sale.date.toLocaleString("hu-HU")}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
